import { ERoles } from './enums/ERoles';
import { RoutePath } from './routes';

export const pcProfileRoute = {
  [ERoles.Client]: RoutePath.CLIENT_CABINET,
  [ERoles.Spec]: RoutePath.SPECIALIST_CABINET,
  [ERoles.Admin]: RoutePath.ADMIN_CABINET,
  [ERoles.Unauthorized]: RoutePath.MAIN,
};
